export default "__VITE_ASSET__C74Z4ndI__"